import { DEFAULT_DEVICE_CONTENT, deviceContent } from '../constants';
import { DeviceContent } from '../types';

export default function useDeviceContent(themeName?: string): DeviceContent {
  return (
    deviceContent.find((device) => device.name === themeName) ||
    DEFAULT_DEVICE_CONTENT
  );
}
